<div class="video-widget-overlay" *ngIf="isVisible">
  <!-- Blocks iframe / media from stealing pointer events while dragging or resizing -->
  <div *ngIf="isInteracting" class="interaction-shield" [style.cursor]="interactionCursor"></div>

  <div class="video-widget-container"
    [class.resizing]="resizingActive"
    [class.dragging]="draggingActive"
    [class.interacting]="isInteracting"
    [class.external-webpage]="isExternalWebPage"
    [style.width.px]="widgetWidth"
    [style.height.px]="widgetHeight"
    [style.left.px]="widgetX"
    [style.top.px]="widgetY">

    <div class="video-widget-header" (pointerdown)="startDrag($event)">
      <div class="widget-controls">
        <button class="control-btn minimize-btn" (click)="minimizeWidget()" title="Minimize">
          <i class="fa fa-minus"></i>
        </button>
        <button class="control-btn maximize-btn" (click)="maximizeWidget()" title="Maximize/Restore">
          <i class="fa fa-expand"></i>
        </button>
        <button class="control-btn close-btn" (click)="closeVideo()" title="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="video-widget-content">
      <ng-container *ngIf="hasMedia; else noMedia">
        <iframe *ngIf="isStream && isExternalWebPage" class="stream-iframe" width="100%" height="100%" frameBorder="0"
          [src]="mediaUrl | safe" scrolling="auto">
        </iframe>

        <rse-player
          *ngIf="isStream && !isExternalWebPage && streamEngineServerUrl"
          class="stream-iframe"
          [serverUrl]="streamEngineServerUrl"
          [url]="mediaUrl"
          [appToken]="streamAppToken"
          [muted]="true"
        ></rse-player>

        <video *ngIf="isVideo" class="fullscreen-video" controls autoplay loop playsinline>
          <source [src]="mediaUrl" type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>

        <img *ngIf="isPhoto" class="fullscreen-photo" [src]="mediaUrl" alt="Alarm media">
      </ng-container>

      <ng-template #noMedia>
        <div class="media-empty-state">
          No media available.
        </div>
      </ng-template>
    </div>

    <div class="resize-handle resize-n" (pointerdown)="startResize($event, 'n')"></div>
    <div class="resize-handle resize-s" (pointerdown)="startResize($event, 's')"></div>
    <div class="resize-handle resize-e" (pointerdown)="startResize($event, 'e')"></div>
    <div class="resize-handle resize-w" (pointerdown)="startResize($event, 'w')"></div>
    <div class="resize-handle resize-ne" (pointerdown)="startResize($event, 'ne')"></div>
    <div class="resize-handle resize-nw" (pointerdown)="startResize($event, 'nw')"></div>
    <div class="resize-handle resize-se" (pointerdown)="startResize($event, 'se')"></div>
    <div class="resize-handle resize-sw" (pointerdown)="startResize($event, 'sw')"></div>
  </div>
</div>
